export default __webpack_public_path__ + "static/media/btn-color-eu_en@2x.a401c9d4.png";